
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help_center/watch_videos",
      function () {
        return require("private-next-pages/help_center/watch_videos/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help_center/watch_videos"])
      });
    }
  